// extracted by mini-css-extract-plugin
module.exports = {"container":"Journey_container__1nN_H","timeline":"Journey_timeline__1Ador"};